import { SUPABASE_URL, SUPABASE_ANON_KEY } from './supabase';

export interface MembershipVerificationResult {
  valid: boolean;
  firstName?: string;
  lastName?: string;
  membershipType?: string;
  error?: string;
}

/**
 * Verifies a player's membership number + surname through the
 * `verify-booking-membership` Edge Function rather than reading
 * "SV Heinersreuth Mitglieder" directly from the browser. The function runs
 * with the service role and returns only whether the pair matched, plus the
 * fields the booking UI displays - never the member row itself.
 *
 * Emergency hotfix (main, 96f6e89): the anon SELECT this used to rely on was
 * revoked in production (member-table PII hardening) before this file existed
 * on main, which made every membership check fail there until the fix shipped.
 *
 * The Supabase target comes from `./supabase` (environment-driven), so the
 * same code reaches staging on a deploy preview and production on main.
 */
export async function verifyBookingMembership(
  membershipNumber: string,
  lastName: string
): Promise<MembershipVerificationResult> {
  try {
    const response = await fetch(`${SUPABASE_URL}/functions/v1/verify-booking-membership`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        apikey: SUPABASE_ANON_KEY,
      },
      body: JSON.stringify({ membershipNumber, lastName }),
    });

    const data = await response.json();
    return data as MembershipVerificationResult;
  } catch {
    // A network/CORS/parse failure here is a TECHNICAL problem, not a
    // mismatch - the caller must not show this as "Mitgliedsdaten falsch".
    return { valid: false, error: 'Fehler bei der Überprüfung. Bitte später erneut versuchen.' };
  }
}
